import { apiSlice } from "../../app/api/apiSlice"
import { HrproStaff } from "../../components/models/HrproStaff"

export const usersApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getUsers: builder.query<HrproStaff, void>({
            query: () => '/User/UserEndpointJson',
        }),
    })
})

export const {
    // useGetUsersQuery,
    useLazyGetUsersQuery
} = usersApiSlice  